import React from 'react';
import styled from 'packages/theming';
import { Box, constants, Loading } from '@match/react-component-library';
import { Footer, Greeting, TopNav, Search } from 'modules/components';
import { useCategories } from 'modules/hooks';

const { SPACE } = constants;
const WIDTH = 1020;

export interface FaqDesktopLayoutProps {
  handle?: string;
  children: React.ReactNode;
}

const FaqDesktopLayout: React.FunctionComponent<FaqDesktopLayoutProps> = ({ children, handle }) => {
  const { areCategoriesLoading } = useCategories();

  return (
    <Box display="flex" flexDirection="column">
      <TopNav />
      <Box
        width="100%"
        height="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        position="absolute"
      >
        <StyledBox
          aria-busy={areCategoriesLoading}
          flex={1}
          marginBottom={SPACE.XLARGE}
          paddingBottom={SPACE.XXXLARGE}
          position="relative"
          width={WIDTH}
        >
          {areCategoriesLoading ? (
            <Box
              alignItems="center"
              display="flex"
              height={500}
              justifyContent="center"
              width={WIDTH}
            >
              <Loading />
            </Box>
          ) : (
            <React.Fragment>
              <Box
                alignItems="flex-end"
                display="flex"
                justifyContent="space-between"
                paddingY={SPACE.LARGE}
                width="100%"
              >
                <Greeting handle={handle} />
                <Search />
              </Box>
              <Box display="flex" justifyContent="center" marginTop={SPACE.XXLARGE} width="100%">
                {children}
              </Box>
            </React.Fragment>
          )}
          <Footer />
        </StyledBox>
      </Box>
    </Box>
  );
};

export default React.memo(FaqDesktopLayout);

const StyledBox = styled(Box)(() => {
  return {
    marginTop: '90px',
  };
});
